import {SiteStore} from '@wix/wixstores-client-storefront-sdk/dist/es/src/viewer-script/site-store/SiteStore';
import {CheckoutNavigationService} from '@wix/wixstores-client-storefront-sdk/dist/es/src/services/CheckoutNavigationService/CheckoutNavigationService';
import {CheckoutApiService} from './checkout-api-service';
import {CheckoutType} from './DirectPurchaseService';
import {IProductDTO, StandaloneCheckoutIds, UserInput, VolatileCartFromServer} from '../types/app-types';
import {CheckoutLegacyMutationsCreateCartArgs} from '@wix/wixstores-graphql-schema-node';
import {ProductService} from './ProductService';
import {StoreMetaDataService} from './StoreMetaDataService';
import {ModalType} from '../constants';
import {SPECS} from '../specs';
import {ReadOnlyExperiments} from '@wix/wix-experiments';

export const VolatileCartApiUrl = '/stores/v1/carts/volatileCart';

export class VolatileCartService {
  private volatileCart: VolatileCartFromServer['cart'] & {checkoutId?: string};
  private readonly checkoutApiService: CheckoutApiService;
  private readonly checkoutNavigationService: CheckoutNavigationService;

  constructor(
    private readonly siteStore: SiteStore,
    private readonly storeMetaDataService: StoreMetaDataService,
    private readonly reportError: (e) => any,
    private readonly wixCodeApi: any,
    private readonly experiments: ReadOnlyExperiments
  ) {
    this.checkoutApiService = new CheckoutApiService(siteStore, wixCodeApi, experiments);
    this.checkoutNavigationService = new CheckoutNavigationService({siteStore, origin: 'product-page'});
  }

  public getStandaloneCheckoutIds = async (
    product: IProductDTO,
    userInputs: UserInput,
    checkoutType: CheckoutType,
    isPreOrderState: boolean
  ): Promise<StandaloneCheckoutIds> => {
    const storeMetaData = await this.storeMetaDataService.fetchStoreInfo();
    const customTextFieldSelection = ProductService.mapCustomTextFields(product, userInputs);
    const isFixVariantIdCalculationInBuyNowFlow = this.experiments.enabled(SPECS.FixVariantIdCalculationInBuyNowFlow);
    const params: CheckoutLegacyMutationsCreateCartArgs = {
      productId: ProductService.getProductId(product),
      optionSelectionId: ProductService.mapOptionSelectionIds(userInputs),
      customTextFieldSelection,
      quantity: ProductService.getQuantity(userInputs),
      subscriptionOptionId: ProductService.getSubscriptionOptionId(userInputs),
      variantId: ProductService.getSelectedVariantId(product, userInputs, isFixVariantIdCalculationInBuyNowFlow),
      options: ProductService.mapUserInputsToSelectedOptions(product, userInputs),
      isPickupOnly: storeMetaData.shipping.isPickupOnly,
    };

    if (isPreOrderState) {
      params.preOrderRequested = true;
    }

    /* istanbul ignore next: todo: test */
    await this.checkoutApiService
      .createCart(params)
      .then((res) => {
        this.volatileCart = res;
      })
      .catch(() => {
        void this.checkoutNavigationService.openModalByType(ModalType.NoOnlinePayments);
        return this.reportError(new Error("Couldn't go to checkout due to volatileCartService error"));
      });

    return {cartId: this.cartId, checkoutId: this.checkoutId};
  };

  public resetCart() {
    this.volatileCart = null;
  }

  public get cartId() {
    return this.volatileCart?.id;
  }

  public get checkoutId() {
    return this.volatileCart?.checkoutId;
  }
}
